import React, { useState, useEffect } from 'react';
import { doc, updateDoc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import './ScheduleModal.css';

const daysOfWeek = ['lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado', 'domingo'];

function ScheduleModal({ sedeId, sedeName, onClose, firestoreCollection = 'reservasSedes' }) {
    const [schedule, setSchedule] = useState({});

    useEffect(() => {
        const fetchSchedule = async () => {
            if (!sedeId) return;
            const sedeRef = doc(db, firestoreCollection, sedeId);
            const sedeSnap = await getDoc(sedeRef);
            if (sedeSnap.exists()) {
                const data = sedeSnap.data();
                const initialSchedule = {};
                daysOfWeek.forEach(day => {
                    initialSchedule[day] = data.schedule?.[day] || [];
                });
                setSchedule(initialSchedule);
            }
        };
        fetchSchedule();
    }, [sedeId, firestoreCollection]);

    const handleTimeChange = (day, index, field, value) => {
        const newSchedule = { ...schedule };
        newSchedule[day][index][field] = value;
        setSchedule(newSchedule);
    };

    const addTimeslot = (day) => {
        const newSchedule = { ...schedule };
        newSchedule[day].push({ start: '09:00', end: '17:00' });
        setSchedule(newSchedule);
    };

    const removeTimeslot = (day, index) => {
        const newSchedule = { ...schedule };
        newSchedule[day].splice(index, 1);
        setSchedule(newSchedule);
    };

    const handleSave = async () => {
        try {
            const sedeRef = doc(db, firestoreCollection, sedeId);
            const dataToSave = {
                schedule,
            };
            if (firestoreCollection === 'menuSedes') {
                dataToSave.name = sedeName;
            } else {
                dataToSave.title = sedeName;
            }
            await setDoc(sedeRef, dataToSave, { merge: true });

            alert('Horario guardado correctamente.');
            onClose();
        } catch (error) {
            console.error("Error saving schedule: ", error);
            alert('Error al guardar el horario.');
        }
    };

    return (
        <div className="modal-backdrop">
            <div className="modal-container">
                <div className="modal-header">
                    <h3>Programar Horario para {sedeName}</h3>
                </div>
                <div className="modal-body">
                    <div className="schedule-editor">
                        {daysOfWeek.map(day => (
                            <div key={day} className="day-schedule">
                                <h4>{day.charAt(0).toUpperCase() + day.slice(1)}</h4>
                                {schedule[day] && schedule[day].map((slot, index) => (
                                    <div key={index} className="timeslot">
                                        <input
                                            type="time"
                                            value={slot.start}
                                            onChange={(e) => handleTimeChange(day, index, 'start', e.target.value)}
                                        />
                                        <span> - </span>
                                        <input
                                            type="time"
                                            value={slot.end}
                                            onChange={(e) => handleTimeChange(day, index, 'end', e.target.value)}
                                        />
                                        <button onClick={() => removeTimeslot(day, index)}>Eliminar</button>
                                    </div>
                                ))}
                                <button onClick={() => addTimeslot(day)}>Agregar Franja</button>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="modal-footer">
                    <div className="modal-actions">
                        <button onClick={handleSave}>Guardar Cambios</button>
                        <button onClick={onClose}>Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ScheduleModal;